import { ThemeProvider, ToastProvider, ProfileSheetProvider, useProfileSheet } from './components/shared';
import HomeScreen from './screens/HomeScreen';
import UserProfileSheet from './components/Profile/UserProfileSheet';

const ProfileSheetRenderer = () => {
  const { profileUserId, close } = useProfileSheet();
  if (!profileUserId) return null;
  return <UserProfileSheet userId={profileUserId} onClose={close}/>;
};

export default function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <ProfileSheetProvider>
          <HomeScreen />
          <ProfileSheetRenderer/>
        </ProfileSheetProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}
